var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_518_3499)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M18.9167 4.95296L22.1565 15.4372H32.6408L24.1588 21.9168L27.3986 32.4011L18.9167 25.9215L10.4348 32.4011L13.6746 21.9168L5.19263 15.4372H15.6769L18.9167 4.95296Z",
    fill: "#F93749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7525 4.78609C18.9919 4.04904 20.0347 4.04904 20.2741 4.78609L23.3575 14.2758L24.0233 14.0595L23.3575 14.2758C23.478 14.6466 23.8236 14.8977 24.2135 14.8977H34.1916C34.9666 14.8977 35.2888 15.8894 34.6618 16.3449L26.5894 22.2099L27.0008 22.7762L26.5894 22.2099C26.2739 22.439 26.1419 22.8453 26.2624 23.2161L29.3458 32.7058C29.5853 33.4429 28.7417 34.0558 28.1147 33.6002L20.0423 27.7353C19.7269 27.5061 19.2997 27.5061 18.9843 27.7353L10.9119 33.6002C10.2849 34.0558 9.44131 33.4429 9.68079 32.7058L12.7642 23.2161C12.8847 22.8453 12.7527 22.439 12.4372 22.2099L4.36481 16.3449C3.73783 15.8894 4.06006 14.8977 4.83503 14.8977H14.8131C15.203 14.8977 15.5486 14.6466 15.6691 14.2758L18.7525 4.78609Z",
    stroke: "#F93749",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90137 4.18328L11.7721 9.78911",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63452 24.2041L1.36134 26.3397",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3262 24.2041L38.9998 26.4731",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5132 32.8804V39.821",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3921 4.18328L26.9875 9.78911",
    stroke: "#F93749",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_518_3499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconRed);
export default __webpack_public_path__ + "static/media/star-icon-red.997dfaa057f81111ac9501132312694c.svg";
export { ForwardRef as ReactComponent };